const home = {
  hero: {
    pillBadge: "Premier Dental Clinic in Bulgaria",
    title: {
      prefix: "Transforming Smiles,",
      emphasis: "Transforming Lives",
    },
    description:
      "Experience world-class dental care with our team of highly skilled professionals. We combine advanced technology with personalized treatment plans to give you the perfect smile you deserve.",
    ctas: {
      primary: "Book an Appointment",
      secondary: "Explore Services",
    },
    specialOffer: {
      guaranteeLabel: "YEAR GUARANTEE",
      price: "2300 £",
      priceLabel: "All on 4",
      bullets: [
        "Premium Quality",
        "Complete Solution",
        "Expert Care",
        "Free Consultation",
      ],
    },
    floatingStats: {
      experience: { small: "Years of", large: "Experience" },
      patients: { small: "Happy", large: "Patients" },
    },
  },
  about: {
    title: "ABOUT US",
    description: "Dedicated to providing exceptional dental care with a gentle touch",
    imageAlt: "Elite Dental Solutions x-ray technology",
    badges: ["Advanced Technology", "Expert Team"],
    paragraphs: [
      "Welcome to Elite Dental Solutions, a premier dental clinic based in Sofia, Bulgaria. Our team of highly experienced and skilled dentists and dental technicians, with over 10 years of expertise, is dedicated to delivering exceptional dental care to both local and international patients.",
      "We take pride in utilizing the latest advancements in dental technology to provide the best possible care for our patients. With over 50 certifications and extensive experience working with international patients, we offer a comprehensive range of dental services to meet your needs and help you achieve a beautiful smile.",
    ],
    checkBullets: [
      "State-of-the-art dental equipment and technology",
      "Multilingual staff for international patients",
      "Personalized treatment plans for every patient",
      "Comprehensive dental tourism services",
    ],
    cta: "Schedule a Consultation",
    stats: [
      {
        value: "10+",
        title: "Years of Experience",
        description: "Over a decade of exceptional dental care",
      },
      {
        value: "5000+",
        title: "Smiling Patients",
        description: "Satisfied patients from around the world",
      },
      {
        value: "20+",
        title: "Master Certifications",
        description: "Highly qualified dental professionals",
      },
      {
        value: "12+",
        title: "Happy Staff",
        description: "Dedicated team of dental experts",
      },
    ],
  },
  services: {
    heading: "OUR SERVICES",
    description: "Comprehensive dental care with a gentle touch and personalized approach",
    learnMore: "Learn more",
    contactCta: "Learn more",
    items: {
      implantology: {
        title: "IMPLANTOLOGY",
        description:
          "Our dental office provides high-quality, long-term tooth replacements that guarantee a natural appearance and feel, blending in perfectly with your natural teeth and greatly enhancing your oral health overall.",
        imageAlt: "Implantology",
      },
      endodontics: {
        title: "ENDODONTICS",
        description:
          "We use a root canal therapy procedure that is patient-friendly in our full practice. As a result, we minimize patient discomfort and maintain the natural beauty of your smile while repairing damaged or infected teeth and restoring their function and health.",
        imageAlt: "Endodontics",
      },
      "oral-surgery": {
        title: "ORAL SURGERY",
        description:
          "Our clinic offers minimally invasive extractions as well as comprehensive therapy for a range of face and dental issues with an emphasis on oral health restoration, patient comfort, and aesthetics.",
        imageAlt: "Oral Surgery",
      },
      periodontology: {
        title: "PERIODONTOLOGY",
        description:
          "Our clinic offers specialized gum treatments and care, focusing on preventing, diagnosing, and treating periodontal disease for improved oral health and overall wellbeing.",
        imageAlt: "Periodontology",
      },
      orthodontics: {
        title: "ORTHODONTICS",
        description:
          "Expert treatments for misaligned teeth are available at our clinic. We employ cutting-edge methods, and every treatment plan is customized to guarantee the greatest possible result for our patients—improving their general appearance as well as their oral health.",
        imageAlt: "Orthodontics",
      },
      bonding: {
        title: "BONDING",
        description:
          "We expertly apply tooth-colored resin to teeth at our office in an effort to improve their appearance. For a seamless, visually beautiful finish that boosts your confidence and smile, we match the resin to the color of your natural teeth.",
        imageAlt: "Bonding",
      },
      prosthetics: {
        title: "PROSTHETICS",
        description:
          "Our dental health center excels in supplying substitute answers for lacking tooth the usage of custom designed bridges or dentures. These prosthetic gadgets are meticulously designed now no longer best to repair function, however additionally to decorate the aesthetics of your smile.",
        imageAlt: "Prosthetics",
      },
      cariesology: {
        title: "CARIESOLOGY",
        description:
          "We offer complete prevention and focused treatment for tooth decay, integrating patient education, routine check-ups, and advanced diagnostics to ensure effective care and long-term oral health.",
        imageAlt: "Cariesology",
      },
      "teeth-whitening": {
        title: "TEETH WHITENING",
        description:
          "Attain a brighter, more youthful smile as we skillfully remove stains and discoloration from your teeth. Our treatments are crafted to enhance your dental aesthetics, delivering a radiant smile that makes a lasting impression.",
        imageAlt: "Teeth Whitening",
      },
      "dental-tourism": {
        title: "DENTAL TOURISM",
        description:
          "Translators, transportation, and accommodation assistance—just book with us, and our dedicated team will take care of every detail, providing a seamless experience tailored to your needs.",
        imageAlt: "Dental Tourism",
      },
    },
  },
  testimonials: {
    heading: "HAPPY PATIENTS",
    subheading: "See what our patients say about their experience with us",
    google: {
      title: "Google Reviews",
      ratingValue: "5.0",
      countLabel: "(63 reviews)",
      readAll: "Read all reviews",
    },
    carousel: {
      prevAria: "Previous testimonial",
      nextAria: "Next testimonial",
    },
    metrics: {
      satisfaction: "Satisfaction Rate",
      positive: "Positive Reviews",
      countries: "Countries Served",
    },
    items: {
      google: {
        g1: {
          content:
            "Nothing short of perfect will do for this Clinic. Their attention to detail is second to none. The staff are so professional yet caring. English is widely spoken by all.",
          name: "Garry Gariside",
          timeAgo: "4 weeks ago",
          initial: "G",
        },
        g2: {
          content:
            "I had the immense pleasure of receiving treatment at Elite Dental Solutions under the care of Dr. Hadzhialish, and I couldn't be more thrilled with the results. I opted for the All-on-4 implant procedure, and from the very beginning, I felt in safe hands.",
          name: "Olen Sr12",
          timeAgo: "2 months ago",
          initial: "O",
        },
        g3: {
          content:
            "The clinic was immaculate. Doctors friendly and efficient. Very happy with the results. Couldn't have been looked after better.",
          name: "Loz Borg",
          timeAgo: "3 months ago",
          initial: "L",
        },
      },
      regular: {
        r1: {
          content:
            "I was nervous about getting dental implants, but the team at Elite Dental Solutions made the entire process smooth and stress-free. From my first consultation to the final result, they were professional, caring, and attentive. I now have a beautiful smile that I'm proud of, and I couldn't be happier with the outcome!",
          name: "Lynn M",
          location: "United Kingdom",
        },
        r2: {
          content:
            "I visited Elite Dental Solutions for teeth whitening before my wedding, and the results were incredible! The staff was so friendly, and they really took the time to explain the procedure to me. My teeth are several shades brighter, and I felt so confident on my big day. Thank you for making my smile picture-perfect!",
          name: "George L",
          location: "Germany",
        },
        r3: {
          content:
            "After years of dealing with tooth sensitivity and gum issues, I finally found the solution at Elite Dental Solutions. Their thorough approach to my treatment and the personalized care I received made all the difference. I can eat and smile without pain now, and I'm so grateful for their expertise and kindness.",
          name: "Alex D",
          location: "Italy",
        },
        r4: {
          content:
            "Having avoided dental work for years due to anxiety, I was amazed by how comfortable the team at Elite Dental Solutions made me feel. They were patient, understanding, and explained everything clearly. The quality of work is outstanding, and for the first time in my life, I don't dread going to the dentist!",
          name: "Sarah K",
          location: "France",
        },
        r5: {
          content:
            "As someone who traveled from abroad specifically for dental work, I couldn't be more impressed with Elite Dental Solutions. They arranged everything from airport pickup to accommodation recommendations. The dental work itself was top-notch, and the cost savings compared to my home country made the trip more than worthwhile.",
          name: "James W",
          location: "United States",
        },
      },
    },
  },
  gallery: {
    heading: "PHOTO GALLERY",
    subheading: "Explore our collection of beautiful smile transformations",
    closeAria: "Close gallery",
    prevAria: "Previous image",
    nextAria: "Next image",
    items: {
      i1: { alt: "Elite Dental Solutions clinic interior", category: "Clinic" },
      i3: { alt: "State-of-the-art dental equipment", category: "Equipment" },
      i4: { alt: "Advanced dental technology", category: "Equipment" },
      i5: { alt: "Dental consultation room", category: "Clinic" },
      i6: { alt: "Dental clinic reception area", category: "Clinic" },
      i7: { alt: "Advanced dental X-ray technology", category: "Technology" },
      i8: { alt: "Dental practice environment", category: "Clinic" },
      i9: { alt: "Modern dental facilities", category: "Clinic" },
      i10: { alt: "Advanced dental workspace", category: "Equipment" },
      i11: { alt: "Professional dental setup", category: "Equipment" },
      i12: { alt: "State-of-the-art dental office", category: "Clinic" },
    },
  },
  contact: {
    heading: "CONTACT US",
    subheading: "We're here to answer your questions and help you schedule your visit",
    cardTitle: "Get in Touch",
    labels: {
      phone: "Phone",
      email: "Email",
      address: "Location",
      workingHours: "Working Hours",
    },
    phone: { telHref: "+359879800430", display: "+359 879 800 430" },
    email: { value: "info@elitedentalsolutions.eu" },
    address: {
      line1: "Manastirski Livadi, zh.k. Manastirski livadi B 65,",
      line2: "1404 Sofia, Bulgaria",
    },
    workingHours: {
      line1: "Monday - Friday: 9:00 - 19:00",
      line2: "Saturday: By Appointment",
    },
    stickyCallText: "Call Now",
    form: {
      title: "Contact Us",
    },
  },
  contactForm: {
    fieldLabels: {
      firstName: "First Name*",
      lastName: "Last Name*",
      email: "Email*",
      phone: "Phone*",
      message: "Message",
    },
    errors: {
      firstNameRequired: "First Name is required",
      lastNameRequired: "Last Name is required",
      emailRequired: "Email is required",
      emailInvalid: "Invalid email address",
      phoneRequired: "Phone number is required",
      phoneInvalid: "Invalid phone number",
    },
    toasts: {
      validationError: {
        title: "Validation Error",
        description: "Please fill in all required fields correctly.",
      },
      success: {
        title: "Message Sent!",
        description: "We'll get back to you as soon as possible.",
      },
      error: {
        title: "Error",
        description: "Failed to send message. Please try again later.",
      },
    },
    submit: {
      idle: "Submit",
      loading: "Sending...",
    },
    privacy: {
      prefix: "By submitting this form, you agree to our",
      linkLabel: "Privacy Policy",
      suffix: ".",
    },
  },
};

export default home;

